export default {"src":"/_next/static/media/ge-room-names.8da48b76.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};